export const LOAD_ARQUIVO = 'LOAD_ARQUIVO';
export const GET_ARQUIVO = 'GET_ARQUIVO';
export const ARQUIVO_ERROR = 'ARQUIVO_ERROR';
